import { render, staticRenderFns } from "./PdfDetailPage.vue?vue&type=template&id=7913584f&scoped=true"
import script from "./PdfDetailPage.vue?vue&type=script&lang=js"
export * from "./PdfDetailPage.vue?vue&type=script&lang=js"
import style0 from "./PdfDetailPage.vue?vue&type=style&index=0&id=7913584f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7913584f",
  null
  
)

export default component.exports